export default {
  computed: {
    programme() {
      return this.$store.getters["Dashboard/currentProgramme"];
    },
    isExemptible() {
      return this.programme[0]
        ? this.programme[0].programme !== "APS-K"
        : false;
    },
  },
  methods: {
    checkExemption() {
      if (!this.isExemptible) {
        this.$alert({
          title: "Permission Denied",
          text: `Sorry, you are not allowed to apply for an exemption. You are currently registered for ${this.programme[0].programme} programme`,
          onClose: () => {
            this.$router.push({ name: "Summary" });
          },
        });
      } else {
        this.$router.push({ name: "ExemptionCard" });
      }
    },
    reopen(item) {
      item.defer = false;
      this.$store.dispatch("Exemption/resubmitDeferedExemption", { ...item });
    },
  },
  watch: {
    programme() {
      if (!this.isExemptible) {
        this.checkExemption();
      }
    },
  },
};
